import http from '@/common/js/http'


// 列表：列表
async function getOrderList(params, This) {
  const res = await http.get('/Order/GetOrderList', params, This);
  if (res != false && res.data.Code == 0) {
    return res.data;
  }
}
// 列表：获取各状态订单数量
async function getOrderTypeNum(params, This) {
  const res = await http.get('/Order/OrderTypeNum', params, This);
  if (res != false && res.data.Code == 0) {
    return res.data.Data
  }
}
//列表：确认发货
async function getSupplierSendGood(params, This) {
  const res = await http.post('/Order/SupplierSendGood', params, This);
  return res;
}
//列表：批量确认发货
async function getSupplierBithSendGoods(params, This) {
  const res = await http.get("/Order/SupplierBithSendGoods", params, This);
  return res.data;
}
// 确认发货：获取物流公司
async function getLogistics(params, This) {
  const res = await http.get('Order/GetLogistics', params, This);
  if (res != false && res.data.Code == 0) {
    return res.data;
  }
}
// 列表：确认订单
async function getSupplierSubOrderConfirm(params, This) {
  const res = await http.post('/Order/SupplierSubOrderConfirm', params, This);
  return res;
}
// 列表：确认取消订单
async function getSupplierSubOrderQX(params, This) {
  const res = await http.post('/Order/SupplierSubOrderQX', params, This);
  return res;
}
//列表：批量导入物流信息
async function getSupplierSendGoods(params, This) {
  const res = await http.post('/ExportImport/SupplierSendGoods', params, This);
  return res;
}
// 列表：待发货批量导出信息
async function getExport(params, This) {
  const res = await http.get("/ExportImport/Export", params, This);
  return res;
}
//列表：批量导入待确认
async function BatchImportConfirmOrders(params, This) {
  const res = await http.post('/ExportImport/BatchImportConfirmOrders', params, This);
  return res;
}
// 列表：待确认批量导出信息
async function ExportBeconfirmedOrders(params, This) {
  const res = await http.get("/ExportImport/ExportBeconfirmedOrders", params, This);
  return res;
}
//列表：待开票批量导入发票信息
async function getImportInvoiceInfo(params, This) {
  const res = await http.post("/ExportImport/ImportInvoiceInfo", params, This);
  return res;
}
//列表：待收款批量导入发票信息
async function BatchConfirmReciveMoney(params, This) {
  const res = await http.post("/ExportImport/BatchConfirmReciveMoney", params, This);
  return res;
}
//列表：待开票批量导出订单
async function getExportOrderPay(params, This) {
  const res = await http.get("/ExportImport/ExportOrderPay", params, This);
  return res;
}
//列表：待收款批量导出订单
async function ExportReceivableOrders(params, This) {
  const res = await http.get("/ExportImport/ExportReceivableOrders", params, This);
  return res;
}
//登录：自动登录
async function getAutologin(params, This) {
  const res = await http.get("/login/autologin", params, This);
  return res;
}
//登录：SSO登录
async function getSsoLogin(params, This) {
  const res = await http.get("/login/SSOLogin", params, This);
  return res;
}
//登录：登录验证
async function getCheckPwd(params, This) {
  const res = await http.get("/login/CheckPwd", params, This);
  return res
}
//登录：获取验证码
async function getRandomNumber(params, This) {
  const res = await http.get("login/GetRandomNumber", params, This);
  if (res != false && res.data.Code == 0) {
    return res.data
  }
}
//首页
async function getIndexInfo(params, This) {
  const res = await http.get("/home/GetIndexInfo", params, This);
  if (res != false && res.data.Code == 0) {
    return res.data;
  }
}
//我的产品
async function getProductList(params, This) {
  const res = await http.post('/Order/GetProductByID', params, This);
  if (res != false && res.data.Code == 0) {
    return res.data;
  }
}
//单品商品信息
async function getDanpin(params, This) {
  const res = await http.get('/Order/GetProductInfo', params, This);
  if (res != false && res.data.Code == 0) {
    return res.data;
  }
}
//成交排名
async function getRank(params, This) {
  const res = await http.post('/Order/BusinessRanking', params, This);
  if (res != false && res.data.Code == 0) {
    return res.data;
  }
}
//计划分析
async function getPlan(params, This) {
  const res = await http.post('/Order/PlanAnalysis', params, This);
  if (res != false && res.data.Code == 0) {
    return res.data;
  }
}
// 详情：数据
async function getOrderDetail(params, This) {
  const res = await http.get('/Order/GetOrderDetail', params, This);
  if (res != false && res.data.Code == 0) {
    return res.data;
  }
}
//详情：物流
async function getLogisticsInfo(params, This) {
  const res = await http.get('/Order/GetLogisticsInfo', params, This);
  return res;
}
//详情：确认少收货
async function getConfirmLessReceipt(params, This) {
  const res = await http.post('/Order/ConfirmLessReceipt', params, This);
  return res;
}
//获取当前账户信息以及获取导航信息
async function getInfo(params, This) {
  const res = await http.get('/login/GetUserInfo', params, This);
  if (res != false && res.data.Code == 0) {
    return res.data;
  }
}
//退出当前账户
async function getAccount(params, This) {
  const res = await http.get('/login/LogOut', params, This);
  if (res != false && res.data.Code == 0) {
    return res.data;
  }
}
//质检报告：数据
async function getQualityReportList(params, This) {
  const res = await http.get('/Order/GetQualityReportList', params, This);
  if (res != false && res.data.Code == 0) {
    return res.data;
  }
}
//质检报告：查看
async function getQualityReportModel(params, This) {
  const res = await http.get("/Order/GetQualityReportModel", params, This);
  if (res != false && res.data.Code == 0) {
    return res.data;
  }
}
// 质检报告：添加
async function getInsertQualityReport(params, This) {
  const res = await http.post("/Order/InsertQualityReport", params, This);
  if (res != false && res.data.Code == 0) {
    return res.data;
  }
}
//质检报告：删除
async function getDeleteQualityReport(params, This) {
  const res = await http.get("/Order/DeleteQualityReport", params, This);
  return res.data;
}
// 我的荣誉
async function getHonor(params, This) {
  const res = await http.post("/Supplier/MyHonor", params, This);
  return res.data;
}
// 提前付款申请页面信息获取
async function GetPrepaymentApplyInfo(params, This) {
  const res = await http.get("/Orderpay/GetPrepaymentApplyInfo", params, This);
  return res.data;
}
//提前付款申请，特殊保理，校验是否已录入发票
async function CheckEPDInvoiceStatus(params, This) {
  const res = await http.get("/Orderpay/CheckEPDInvoiceStatus", params, This);
  return res.data;
}
//总包特殊保理，提交提前付款申请(利息天数确认)
async function SubmitPrepaymentConfirmDayApply(params, This) {
  const res = await http.post("/Orderpay/SubmitPrepaymentConfirmDayApply", params, This);
  return res.data;
}
// 提交提前付款申请
async function SubmitPrepaymentApply(params, This) {
  const res = await http.post("/Orderpay/SubmitPrepaymentApply", params, This);
  return res.data;
}
//确认收款
async function getConfirmCollectMoney(params, This) {
  const res = await http.get("/supplier/ConfirmCollectMoney", params, This);
  return res.data;
}
//结算清单查询
async function getSettlementList(params, This) {
  const res = await http.post("/SupplierSettlement/GetSettlementList", params, This);
  return res.data;
}
//列表：导出全部
async function ExportAllOrders(params, This) {
  const res = await http.post("/ExportImport/ExportAllOrders", params, This);
  return res.data;
}
//密码修改
async function ChangePassword(params, This) {
  const res = await http.post("/login/ChangePassword", params, This);
  return res.data;
}
//结算单打印
async function getSupplierSettlementDetail(params, This) {
  const res = await http.post("/SupplierSettlement/GetSupplierSettlementDetail", params, This);
  return res.data;
}
//结算单查看明细
async function getSettlementDetailList(params, This) {
  const res = await http.post("/SupplierSettlement/GetSettlementDetailList", params, This);
  return res.data;
}
//录入发票删除
async function getInvoiceDelete(params, This) {
  const res = await http.get("/SupplierSettlement/InvoiceDelete", params, This);
  return res.data;
}
//录入发票新增编辑
async function getInvoiceInsertUpdate(params, This) {
  const res = await http.post("/SupplierSettlement/InvoiceInsertUpdate", params, This);
  return res.data;
}
//订单录入发票页面
async function getorderinvoicedetail(params, This) {
  const res = await http.get("/order/getorderinvoicedetail", params, This);
  return res.data;
}
//订单发票列表
async function GetInvoiceListByPayNo(params, This) {
  const res = await http.get("/order/GetInvoiceListByPayNo", params, This);
  return res.data;
}
//订单发票保存新增
async function getInsertInvoice(params, This) {
  const res = await http.post("/invoice/InsertInvoice", params, This);
  return res.data;
}

// 退货  退货/退款 data
async function getRemburseloadData(params, This) {
  const res = await http.get("/order/GetAfterSalfInfo", params, This);
  return res.data;
}

//确认退货 确认退货退款
///order/GetAfterSalfInfo
async function referAffirmRefund(params, This) {
  const res = await http.get("/order/ConfimAfterSalf", params, This);
  return res.data;
}

// 确认订单
async function saveSupplierSubOrderConfirm(params, This) {
  const res = await http.post("/Order/SupplierSubOrderConfirm", params, This);
  return res.data;
}

// 修改运费
async function setModifyTheFreight(params, This) {
  const res = await http.get("/Order/UpdateFreight", params, This);
  return res.data;
}

//订单发票保存新增
async function GetOrderPrintInfo(params, This) {
  const res = await http.get("/order/GetOrderPrintInfo", params, This);
  return res.data;
}

//特许店查询
async function ReconciliationList(params, This) {
  const res = await http.post("/supplier/ReconciliationList", params, This);
  return res.data;
}
//特许店,直营店查询导出
async function ExportReconciliationList(params, This) {
  const res = await http.post("/ExportImport/ExportReconciliationList", params, This);
  return res.data;
}
//特许店杉德对账查询
async function GetFranchiseBillByShanDe(params, This) {
  const res = await http.post("/OrderPay/GetFranchiseBillByShanDe", params, This);
  return res.data;
}
//特许店杉德对账查询 导出
async function ExportFranchiseBillByShanDe(params, This) {
  const res = await http.get("/ExportImport/ExportFranchiseBillByShanDe", params, This);
  return res.data;
}
//特许店线下支付对账查询
async function GetFranchiseBillOffline(params, This) {
  const res = await http.post("/OrderPay/GetFranchiseBillOffline", params, This);
  return res.data;
}
//特许店线下支付对账查询 导出
async function ExportFranchiseBillByOffline(params, This) {
  const res = await http.get("/ExportImport/ExportFranchiseBillByOffline", params, This);
  return res.data;
}
//获取产品详情
async function GetProductDetail(params, This) {
  const res = await http.get("/Supplier/GetProductDetail", params, This);
  return res.data;
}
//忘记密码
async function ForgetPassword(params, This) {
  const res = await http.post("/Login/ForgetPassword", params, This);
  return res.data;
}
//获取杉德提现明细
async function GetShanDeWithdraw(params, This) {
  const res = await http.post("/OrderPay/GetShanDeWithdraw", params, This);
  return res.data;
}
//特许店杉德提现查询 导出
async function ExportShanDeWithdraw(params, This) {
  const res = await http.get("/ExportImport/ExportShanDeWithdraw", params, This);
  return res.data;
}
//上传图片
async function Upload(params, This) {
  const res = await http.post("/ajax/Upload", params, This);
  return res.data;
}
//获取上传的产品图片
async function GetProductUploadImgList(params, This) {
  const res = await http.get("/Supplier/GetProductImgList", params, This);
  return res.data;
}
//删除上传的产品图片
async function DeleteSupplierUploadProductImg(params, This) {
  const res = await http.get("/Supplier/DeleteSupplierUploadProductImg", params, This);
  return res.data;
}
//获取酒店列表
async function GetHotelList(params, This) {
  const res = await http.post("/Supplier/GetHotelList", params, This);
  return res.data;
}
//上传附件
async function UploadVue(params, This) {
  const res = await http.post("/ajax/UploadVue", params, This);
  return res.data;
}
// 非标报备
async function getNonStandardList(params, This) {
  const res = await http.get("/NonStandard/GetList", params, This);
  return res.data;
}
async function getNonStandardHotelList(params, This) {
  const res = await http.get("/NonStandard/GetHotelList", params, This);
  return res.data;
}
async function getNonStandardSupplierList(params, This) {
  const res = await http.get("/NonStandard/GetSupplierList", params, This);
  return res.data;
}
async function getNonStandardProductTypes(params, This) {
  const res = await http.get("/NonStandard/GetProductTypes", params, This);
  return res.data;
}
async function saveNonStandard(params, This) {
  const res = await http.post("/NonStandard/Save", params, This);
  return res.data;
}
async function submitNonStandard(params, This) {
  const res = await http.post("/NonStandard/Submit", params, This);
  return res.data;
}
async function deleteNonStandard(params, This) {
  const res = await http.post("/NonStandard/Delete", params, This);
  return res.data;
}
async function exportNonStandard(params, This) {
  const res = await http.post("/NonStandard/Export", params, This);
  return res.data;
}
//上传附件
async function UploadVue(params, This) {
  const res = await http.post("/ajax/UploadVue", params, This);
  return res.data;
}
//获取导入的订单列表
async function GetOrderImportList(params, This) {
  const res = await http.get("/orderimport/GetOrderImportList", params, This);
  return res.data;
}
//保存导入订单数据
async function SaveOrderImportData(params, This) {
  const res = await http.post("/orderimport/SaveOrderImportData", params, This);
  return res.data;
}
//保存导入订单明细数据
async function GetOrderImportDetail(params, This) {
  const res = await http.get("/orderimport/GetOrderImportDetail", params, This);
  return res.data;
}
//删除已导入的订单
async function DeleteOrderImport(params, This) {
  const res = await http.post("/orderimport/DeleteOrderImport", params, This);
  return res.data;
}
//按导入ID获取导入订单列表
async function GetImportOrderByOrderImportID(params, This) {
  const res = await http.get("/orderimport/GetImportOrderByOrderImportID", params, This);
  return res.data;
}
//获取订单评价列表
async function getcommentlist(params, This) {
  const res = await http.get("/shop/GetSupplierOrderCommentList", params, This);
  return res.data;
}
//获取SKU评价列表
async function getSKUEvaluationlist(params, This) {
  const res = await http.get("/shop/GetSKUEvaluationList", params, This);
  return res.data;
}
//导出订单评价列表
async function exportordercomment(params, This) {
  const res = await http.post("/exportimport/ExportOrderComment", params, This);
  return res.data;
}
//获取公告列表
async function getNoticeList(params, This) {
  const res = await http.get("/supplier/getNoticeList", params, This);
  return res.data;
}
//获取店铺信息
async function GetShopInfo(params, This) {
  const res = await http.get("/shop/GetShopInfo", params, This);
  return res.data;
}
//修改店铺信息
//获取洗涤服务设备图片
async function GetLaundryServiceEquipment(params, This) {
  const res = await http.get("/shop/GetLaundryServiceEquipment", params, This);
  return res.data;
}
//保存洗涤服务设备图片
async function SaveLaundryServiceEquipment(params, This) {
  const res = await http.post("/shop/SaveLaundryServiceEquipment", params, This);
  return res.data;
}
//获取洗涤服务范围城市
async function GetLaundryServiceCityInfo(params, This) {
  const res = await http.get("/shop/GetLaundryServiceCityInfo", params, This);
  return res.data;
}
async function ChangeShopInfo(params, This) {
  const res = await http.post("/shop/ChangeShopInfo", params, This);
  return res.data;
}
//获取供应商信息变更记录
async function getchangelist(params, This) {
  const res = await http.get("/shop/getchangelist", params, This);
  return res.data;
}
//变更联系人
async function ChangeContacts(params, This) {
  const res = await http.post("/shop/ChangeContacts", params, This);
  return res.data;
}
//获取供应商证照
async function GetSupplierLicenceList(params, This) {
  const res = await http.get("/shop/GetSupplierLicenceList", params, This);
  return res.data;
}
//保存供应商证照
async function SaveSupplierLicence(params, This) {
  const res = await http.post("/shop/SaveSupplierLicence", params, This);
  return res.data;
}
//保存供应商物流
async function SaveSupplierLogistics(params, This) {
  const res = await http.post("/shop/SaveSupplierLogistics", params, This);
  return res.data;
}
//获取供应商物流
async function GetLogisticsList(params, This) {
  const res = await http.get("/shop/GetLogisticsList", params, This);
  return res.data;
}
//保存供应商公告
async function SaveSupplierNotice(params, This) {
  const res = await http.post("/shop/SaveSupplierNotice", params, This);
  return res.data;
}
//保存供应商已阅读公告(2023年11月过后的)
async function SaveSupplierGGQR(params, This) {
  const res = await http.post("/shop/SaveSupplierGGQR", params, This);
  return res.data;
}
//商品报表
async function getProdList(params, This) {
  const res = await http.post("/product/getProdList", params, This);
  return res.data;
}
//预订单
async function getpreorderList(params, This) {
  const res = await http.post("/product/getpreorderList", params, This);
  return res.data;
}
//商品维护
async function prodchange(params, This) {
  const res = await http.post("/product/prodchange", params, This);
  return res.data;
}
//获取商品变更信息
async function getprodchange(params, This) {
  const res = await http.get("/product/getprodchange", params, This);
  return res.data;
}
//获取商品变更信息
async function getProdDetail(params, This) {
  const res = await http.get("/product/getProdDetail", params, This);
  return res.data;
}
//获取产品类别
async function getproducttype(params, This) {
  const res = await http.get("/product/getproducttype", params, This);
  return res.data;
}
//导出商品列表
async function exportproduct(params, This) {
  const res = await http.post("/exportimport/exportproduct", params, This);
  return res.data;
}
//导出预新增列表
async function exportpreorder(params, This) {
  const res = await http.post("/exportimport/exportpreorder", params, This);
  return res.data;
}
//获取待办列表
async function gettodolist(params, This) {
  const res = await http.get("/home/gettodolist", params, This);
  return res.data;
}
//更新待办状态
async function updatetodostatus(params, This) {
  const res = await http.get("/home/updatetodostatus", params, This);
  return res.data;
}
//保存电脑序列号
async function savecomputersn(params, This) {
  const res = await http.post("/order/savecomputersn", params, This);
  return res.data;
}
//获取供应商开票信息
async function getinvoicetitle(params, This) {
  const res = await http.get("/shop/GetInvoiceTitle", params, This);
  return res.data;
}
//保存发票信息
async function saveinvoicetitle(params, This) {
  const res = await http.post("/shop/SaveInvoiceTitle", params, This);
  return res.data;
}
//获取收货异议列表
async function GetReceiveObjectionList(params, This) {
  const res = await http.get('/Order/GetReceiveObjectionList', params, This);
  if (res && res.data) {
    return res.data;
  }
  return { Code: -1, Message: '网络异常，请稍后重试' };
}
//历史未完成订单状态确认
async function GetUnConfirmPOList(params, This) {
  const res = await http.get('/Order/GetUnConfirmPOList', params, This);
  if (res && res.data) {
    return res.data;
  }
  return { Code: -1, Message: '网络异常，请稍后重试' };
}
//导出历史未完成订单状态确认
async function exportUnConfirmPO(params, This) {
  const res = await http.post("/exportimport/ExportUnConfirmPO", params, This);
  return res.data;
}
//列表：批量导入历史未完成订单状态确认
async function ImportUnConfirmPO(params, This) {
  const res = await http.post('/ExportImport/ImportUnConfirmPO', params, This);
  return res;
}
//根据订单号获取收货异议记录
async function GetReceiveObjection(params, This) {
  const res = await http.get('/Order/GetReceiveObjection', params, This);
  if (res && res.data) {
    return res.data;
  }
  return { Code: -1, Message: '网络异常，请稍后重试' };
}
//添加收货异议记录
async function SaveReceiveObjection(params, This) {
  const res = await http.post('/Order/SaveReceiveObjection', params, This);
  if (res && res.data) {
    return res.data;
  }
  return { Code: -1, Message: '网络异常，请稍后重试' };
}
//保存订单收货单
async function SaveOrderReceipt(params, This) {
  const res = await http.post('/Order/SaveOrderReceipt', params, This);
  if (res != false && res.data.Code == 0) {
    return res.data;
  }
}
//保存待收货物流附件（不作为自动收货凭证）
async function SaveLogisticsAttachment(params, This) {
  const res = await http.post('/Order/SaveLogisticsAttachment', params, This);
  if (res && res.data) {
    return res.data;
  }
  return { Code: -1, Message: '网络异常，请稍后重试' };
}
//保存货品送至地点
async function savesupplylocation(params, This) {
  const res = await http.get("/shop/SaveSupplyLocation", params, This);
  return res.data;
}
//获取系统公告详情
async function getNoticeDetail(params, This) {
  const res = await http.get("/supplier/getNoticeDetail", params, This);
  return res.data;
}
//获取拼单订单列表
async function GetSpellOrderList(params, This) {
  const res = await http.get("/spellorder/GetSpellOrderList", params, This);
  return res.data;
}
//确认拼单
async function SpellOrderConfirm(params, This) {
  const res = await http.post("/spellorder/SpellOrderConfirm", params, This);
  return res.data;
}
//修改拼单运费
async function UpdateSpellOrderFreight(params, This) {
  const res = await http.post("/spellorder/UpdateSpellOrderFreight", params, This);
  return res.data;
}
//拼单发货
async function SpellOrderSendGood(params, This) {
  const res = await http.post("/spellorder/SpellOrderSendGood", params, This);
  return res.data;
}
//获取拼单详情
async function GetSupplierSpellOrderDetail(params, This) {
  const res = await http.get("/spellorder/GetSupplierSpellOrderDetail", params, This);
  return res.data;
}
//更新首页弹出信息显示状态
async function UpdateSupplierForcettipsShowStatus(params, This) {
  const res = await http.get("/home/UpdateSupplierForcettipsShowStatus", params, This);
  return res.data;
}
//获取待付款列表
async function getSupplierPayInvoicePaymentList(params, This) {
  const res = await http.get("/PayInvoice/GetPaymentList", params, This);
  return res.data;
}
//提交支付凭证
async function submitPayVoucher(params, This) {
  const res = await http.post("/PayInvoice/SubmitPayVoucher", params, This);
  return res.data;
}
//获取付款单据详情
async function getPrepaymentApplicationByPreNo(params, This) {
  const res = await http.get("/PayInvoice/GetPrepaymentApplicationByPreNo", params, This);
  return res.data;
}
//获取供应商发票列表
async function getSupplierInvoiceList(params, This) {
  const res = await http.get("/PayInvoice/GetInvoiceList", params, This);
  return res.data;
}
//获取返利账单列表
async function GetRebateList(params, This) {
  const res = await http.get("/Rebate/GetRebateList", params, This);
  return res.data;
}
//获取返利账单明细
async function GetRebateDetail(params, This) {
  const res = await http.get("/Rebate/GetRebateDetail", params, This);
  return res.data;
}
//获取品牌组
async function GetGroupBrandList(params, This) {
  const res = await http.get("/ajax/GetGroupBrandList", params, This);
  return res.data;
}
//保存返利账单明细
async function SaveSupplierRebateBillDetailLog(params, This) {
  const res = await http.post("/Rebate/SaveSupplierRebateBillDetailLog", params, This);
  return res.data;
}
//获取返利账单调整记录
async function GetSupplierRebateBillDetailLog(params, This) {
  const res = await http.post("/Rebate/GetSupplierRebateBillDetailLog", params, This);
  return res.data;
}
//确认返利账单
async function ConfirmSupplierRebateBill(params, This) {
  const res = await http.post("/Rebate/ConfirmSupplierRebateBill", params, This);
  return res.data;
}
//导出返利账单明细
async function ExportRebateDetail(params, This) {
  const res = await http.post("/ExportImport/ExportRebateDetail", params, This);
  return res.data;
}
//回复订单评价
async function ReplySupplierOrderComment(params, This) {
  const res = await http.post("/shop/ReplySupplierOrderComment", params, This);
  return res.data;
}
//回复SKU评价
async function SupplierSKUReply(params, This) {
  const res = await http.post("/shop/SupplierSKUReply", params, This);
  return res.data;
}
//获取订单状态数量-new
async function GetOrderStatusNum(params, This) {
  const res = await http.get("/order/GetOrderStatusNum", params, This);
  return res.data;
}
//获取订单报表查询
async function GetOrderReport(params, This) {
  const res = await http.post("/order/GetOrderReport", params, This);
  return res.data;
}
//获取订单报表明细查询
async function GetOrderReportDetail(params, This) {
  const res = await http.post("/order/GetOrderReportDetail", params, This);
  return res.data;
}
//获取线下付款信息
async function GetOrderPayCertificate(params, This) {
  const res = await http.get("/order/GetOrderPayCertificate", params, This);
  return res.data;
}
//订单发票寄出标记
async function OrderInvoiceSendFlag(params, This) {
  const res = await http.get("/order/OrderInvoiceSendFlag", params, This);
  return res.data;
}
//获取状态数量和消息
async function GetSupplierMsgNotifInfo(params, This) {
  const res = await http.get("/home/GetSupplierMsgNotifInfo", params, This);
  return res.data;
}
//更新供应商物流和售后公共信息
async function UpdateSupplierLogisticsAftersales(params, This) {
  const res = await http.post("/product/UpdateSupplierLogisticsAftersales", params, This);
  return res.data;
}
//获取供应商多最小起订金额
async function GetSupplierManyMinMoney(params, This) {
  const res = await http.get("/shop/GetSupplierManyMinMoney", params, This);
  return res.data;
}



//所有商品列表
async function AllProdList(params, This) {
  const res = await http.post('product/AllProdList', params, This);
  return res.data
}

//批量保存返利明细数据
async function SaveSupplierRebateBillDetailLogBatch(params, This) {
  const res = await http.post("/rebate/SaveSupplierRebateBillDetailLogBatch", params, This);
  return res.data;
}

//供应商上传发票
async function UploadInvoice(params, This) {
  const res = await http.post("/order/UploadInvoice", params, This);
  if (res == undefined)
    return res;
  return res.data;
}
//供应商上传发票
async function UploadPreOrder(params, This) {
  const res = await http.post("/ajax/UploadPreOrder", params, This);
  if (res == undefined)
    return res;
  return res.data;
}
//供应商上传发票
async function SavePreOrder(params, This) {
  const res = await http.post("/ajax/SavePreOrder", params, This);
  if (res == undefined)
    return res;
  return res.data;
}

//查询发票附件接口
async function QueryInvoiceAttachmentList(params, This) {
  const res = await http.get("/order/QueryInvoiceAttachmentList", params, This);
  return res.data;
}

//供应商确认先估后审5%尾款
async function OrderXGHSFKQR(payno, This) {
  const res = await http.get("/order/OrderXGHSFKQR", payno, This);
  return res.data;
}

//供应商特许酒店产品列表
async function SupplierProductTXHotelList(params, This) {
  const res = await http.post('product/SupplierProductTXHotelList', params, This);
  return res.data;
}

//特许产品加购-购物车
async function AddSupplierProduct(params, This) {
  const res = await http.post('product/AddSupplierProduct', params, This);
  return res.data;
}
//特许产品-购物车查询
async function GetCartProductList(params, This) {
  const res = await http.post('product/GetCartProductList', params, This);
  return res.data;
}
//特许产品-购物车删除
async function DelSupplierProduct(params, This) {
  const res = await http.post('product/DelSupplierProduct', params, This);
  return res.data;
}
//特许产品-购物车提交订单
async function SubmitSupplierOrder(params, This) {
  const res = await http.post('product/SubmitSupplierOrder', params, This);
  return res.data;
}
async function ConfirmImportSupplierProductToCart(params, This) {
  const res = await http.post('product/ConfirmImportSupplierProductToCart', params, This);
  return res.data;
}
//特许产品-供应商提交列表查询
async function GetOrderSupplierList(params, This) {
  const res = await http.post('product/GetOrderSupplierList', params, This);
  return res.data;
}
//扣分明细列表
async function SupplierKpiRewardList(params, This) {
  const res = await http.post('shop/SupplierKpiRewardList', params, This);
  return res.data
}
//保存供应商平台调查问卷
async function SaveSupplierSurvey(params, This) {
  const res = await http.post("/supplier/SaveSupplierSurvey", params, This);
  return res.data;
}
//扣分明细列表详情
async function GetSupplierKPIDetailLog(params, This) {
  const res = await http.post("/shop/GetSupplierKPIDetailLog", params, This);
  return res.data;
}

//获取税务异常供应商
async function GetTaxRiskSupplier(params,This) {
  const res = await http.get("/order/GetTaxRiskSupplier", params, This);
  return res.data;
}
//检查供应商是否有查看酒店设计图的权限
async function CheckDesignViewPermission(params, This) {
  const res = await http.get("/Supplier/CheckDesignViewPermission", params, This);
  return res.data;
}
export default {
  GetSupplierManyMinMoney,
  UpdateSupplierLogisticsAftersales,
  GetSupplierMsgNotifInfo,
  OrderInvoiceSendFlag,
  GetOrderPayCertificate,
  GetOrderReportDetail,
  GetOrderReport,
  GetOrderStatusNum,
  SaveSupplierRebateBillDetailLogBatch,
  ReplySupplierOrderComment,
  SupplierSKUReply,
  ExportRebateDetail,
  GetSupplierSpellOrderDetail,
  SpellOrderSendGood,
  UpdateSpellOrderFreight,
  SpellOrderConfirm,
  GetSpellOrderList,
  ConfirmSupplierRebateBill,
  GetSupplierRebateBillDetailLog,
  SaveSupplierRebateBillDetailLog,
  GetGroupBrandList,
  GetRebateDetail,
  GetRebateList,
  getSupplierInvoiceList,
  getPrepaymentApplicationByPreNo,
  submitPayVoucher,
  getSupplierPayInvoicePaymentList,
  UpdateSupplierForcettipsShowStatus,
  getNoticeDetail,
  savesupplylocation,
  SaveOrderReceipt,
  SaveLogisticsAttachment,
  SaveReceiveObjection,
  GetReceiveObjection,
  GetReceiveObjectionList,
  GetUnConfirmPOList,
  exportUnConfirmPO,
  ImportUnConfirmPO,
  saveinvoicetitle,
  getinvoicetitle,
  updatetodostatus,
  gettodolist,
  exportproduct,
  exportpreorder,
  getproducttype,
  getProdDetail,
  getpreorderList,
  getprodchange,
  prodchange,
  getProdList,
  SaveSupplierNotice,
  SaveSupplierGGQR,
  GetLogisticsList,
  SaveSupplierLogistics,
  SaveSupplierLicence,
  GetSupplierLicenceList,
  ChangeContacts,
  getchangelist,
  GetLaundryServiceEquipment,
  SaveLaundryServiceEquipment,
  GetLaundryServiceCityInfo,
  ChangeShopInfo,
  GetShopInfo,
  getNoticeList,
  exportordercomment,
  getcommentlist,
  savecomputersn,
  getSKUEvaluationlist,
  GetImportOrderByOrderImportID,
  DeleteOrderImport,
  GetOrderImportDetail,
  SaveOrderImportData,
  GetOrderImportList,
  getNonStandardList,
  getNonStandardHotelList,
  getNonStandardSupplierList,
  getNonStandardProductTypes,
  saveNonStandard,
  submitNonStandard,
  deleteNonStandard,
  exportNonStandard,
  UploadVue,
  GetHotelList,
  DeleteSupplierUploadProductImg,
  GetProductUploadImgList,
  Upload,
  ExportShanDeWithdraw,
  GetShanDeWithdraw,
  ForgetPassword,
  GetProductDetail,
  ExportFranchiseBillByOffline,
  GetFranchiseBillOffline,
  ExportFranchiseBillByShanDe,
  GetFranchiseBillByShanDe,
  ExportReconciliationList,
  ReconciliationList,
  GetOrderPrintInfo,
  getOrderList,
  getOrderTypeNum,
  getSupplierSendGood,
  getSupplierBithSendGoods,
  getSupplierSubOrderConfirm,
  getSupplierSubOrderQX,
  getSupplierSendGoods,
  getExport,
  getExportOrderPay,
  BatchConfirmReciveMoney,
  ExportReceivableOrders,
  getImportInvoiceInfo,
  getLogistics,
  BatchImportConfirmOrders,
  ExportBeconfirmedOrders,
  getAutologin,
  getSsoLogin,
  getCheckPwd,
  getRandomNumber,
  getIndexInfo,
  getProductList,
  getRank,
  getOrderDetail,
  getLogisticsInfo,
  getConfirmLessReceipt,
  getDanpin,
  getPlan,
  getInfo,
  ExportAllOrders,
  //getNav,
  ChangePassword,
  getAccount,
  getQualityReportList,
  getQualityReportModel,
  getInsertQualityReport,
  getDeleteQualityReport,
  getHonor,
  GetPrepaymentApplyInfo,
  CheckEPDInvoiceStatus,
  SubmitPrepaymentConfirmDayApply,
  SubmitPrepaymentApply,
  getSettlementList,
  getSupplierSettlementDetail,
  getSettlementDetailList,
  getInvoiceDelete,
  getInvoiceInsertUpdate,
  getorderinvoicedetail,
  GetInvoiceListByPayNo,
  getInsertInvoice,
  getConfirmCollectMoney,
  getRemburseloadData,
  referAffirmRefund,
  setModifyTheFreight,
  saveSupplierSubOrderConfirm,
  AllProdList,
  UploadInvoice,
  UploadPreOrder,
  SavePreOrder,
  QueryInvoiceAttachmentList,
  OrderXGHSFKQR,
  SupplierProductTXHotelList,
  AddSupplierProduct,
  GetCartProductList,
  DelSupplierProduct,
  ConfirmImportSupplierProductToCart,
  SubmitSupplierOrder,
  GetOrderSupplierList,
  SupplierKpiRewardList,
  SaveSupplierSurvey,
  GetSupplierKPIDetailLog,
  GetTaxRiskSupplier,
  CheckDesignViewPermission
}



// WEBPACK FOOTER //
// ./src/common/js/api.js